var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"edam-select\">\n\n  <div>\n    <button class=\"btn-danger remove-edge\">Remove edge</button>\n  </div>\n\n  <hr>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_mode/edge.hbs
// module id = 141
// module chunks = 0